export type CancellationReason = {
  readonly id: number;
  readonly name: string;
};

export function createCancellationReason(values: unknown): CancellationReason {
  const { id, name } = values as CancellationReason;

  return {
    id,
    name,
  };
}
